import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { SystemPopup } from '@gongxigames/framework/slot/types';
import {
    PromotionData,
    MultiSetsPromotionLogic,
    MultiSetsPromotionStates,
    MultiSetsPromotionModule,
    MultiSetsPromotionModuleEvents,
} from '@gongxigames/framework/promotions';

export class MultiSetsPromotionStartState extends ModuleState<null, MultiSetsPromotionModule, MultiSetsPromotionModuleEvents> {
    protected startPopup?: SystemPopup;

    public onEnterState(): void {
        const promotion = this.module.getPromotion();
        const isContinue = promotion.isActive();

        this.startPopup = isContinue ? this.createContinuePopup() : this.createStartPopup();

        this.emit('General.Slot.SPIN.DISABLE', MultiSetsPromotionModule.NAME);
        this.emit('General.UI.DISABLE', MultiSetsPromotionModule.NAME);
        this.emit('Autoplay.FORCE_STOP');

        this.module.showPopup(this.startPopup);
    }

    protected createStartPopup(): SystemPopup {
        return this.module.popups.createMultiSetsPromotionStartPopup({
            ...this.promotionData,
            onClickAskMeLater: this.onClickAskMeLater.bind(this),
            onClickAccept: this.onClickAccept.bind(this),
        });
    }

    protected createContinuePopup(): SystemPopup {
        return this.module.popups.createMultiSetsPromotionContinuePopup({
            ...this.promotionData,
            onClickKeepGoing: this.onClickKeepGoing.bind(this),
        });
    }

    public onLeaveState(): void {
        this.emit('MultiSetsPromotion.START_STATE_LEFT');
        this.emit('General.UI.ENABLE', MultiSetsPromotionModule.NAME);
        this.emit('General.Slot.SPIN.ENABLE', MultiSetsPromotionModule.NAME);

        if (this.module.getPromotion().isActive()) {
            this.emit('General.Promotion.Started');
        }
    }
    protected onClickAccept(): void {
        this.hidePopup();
        this.module.getPromotion<MultiSetsPromotionLogic>().accept(() => {
            this.gotoInProgressState();
        });
    }

    protected onClickKeepGoing(): void {
        this.hidePopup();
        this.gotoInProgressState();
    }

    protected onClickAskMeLater(): void {
        this.hidePopup();
        this.module.getPromotion<MultiSetsPromotionLogic>().reject(() => {
            this.module.gotoState(MultiSetsPromotionStates.DISABLED);
            this.emit('General.Promotion.Ended');
        });
    }

    protected gotoInProgressState(): void {
        this.module.gotoState(MultiSetsPromotionStates.IN_PROGRESS);
    }

    protected hidePopup(): void {
        if (this.startPopup) {
            this.module.hidePopup(this.startPopup);
            this.startPopup = undefined;
        }
    }

    protected get promotionData(): PromotionData {
        return this.module.getPromotion().getData();
    }

    protected setupEvents(): void {}
}
